import { useQuery } from '@tanstack/react-query';
import { enhancedSitemapService } from '@/services/enhancedSitemapService';

// Hook to automatically update sitemap when blog posts change
export const useSitemapAutoUpdate = () => {
  return useQuery({
    queryKey: ['sitemap-auto-update'],
    queryFn: async () => {
      try {
        const sitemapContent = await enhancedSitemapService.generateSitemap();
        
        // Log the updated sitemap content for manual update
        console.log('🔄 Auto-generated sitemap content:');
        console.log(sitemapContent);
        console.log('💡 Copy this content to public/sitemap.xml to update your sitemap');
        
        return {
          content: sitemapContent,
          lastGenerated: new Date().toISOString(),
          success: true
        };
      } catch (error) {
        console.error('❌ Failed to auto-generate sitemap:', error);
        return {
          content: null,
          lastGenerated: new Date().toISOString(),
          success: false,
          error: error instanceof Error ? error.message : 'Unknown error'
        };
      }
    },
    staleTime: 1000 * 60 * 30, // 30 minutes
    gcTime: 1000 * 60 * 60, // 1 hour
    refetchInterval: 1000 * 60 * 60 * 24, // Refetch daily
    retry: 2,
  });
};

// Hook to trigger sitemap generation on demand
export const useSitemapGeneration = () => {
  return useQuery({
    queryKey: ['generate-sitemap-now'],
    queryFn: () => enhancedSitemapService.generateSitemap(),
    enabled: false, // Only run when manually triggered
    retry: 1,
  });
};